/**
 * Mirrors com.medprompt.document.status.DocumentStatus
 */
export const DocumentStatus = Object.freeze({
  NON_EXISTENT: 'NON_EXISTENT',
  PENDING: 'PENDING',
  GENERATING: 'GENERATING',
  READY: 'READY',
  INVALID: 'INVALID',
  QUEUED_FOR_FILING: 'QUEUED_FOR_FILING',
  FILED_AWAY: 'FILED_AWAY',
  SKIPPED: 'SKIPPED',
  EDITING: 'EDITING',
});
